import { render, staticRenderFns } from "./mapTaskEndpointPopover.vue?vue&type=template&id=04805b01&"
import script from "./mapTaskEndpointPopover.vue?vue&type=script&lang=js&"
export * from "./mapTaskEndpointPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports